import React from 'react';
import ChallengerDevisHeader from '../6-challenger-devis/components/ChallengerDevisHeader';
import DevisTable from '../6-challenger-devis/components/DevisTable';

const ChallengerDevis: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <ChallengerDevisHeader />
        <DevisTable />
      </div>
    </div>
  );
};

export default ChallengerDevis;
